<template>
  <div class="my-item z-info">
    <template >
      <div style="min-height: 400px;">
        <Row :gutter="30">
          <Col
            :md="12"
            :xl="8"
            :xxl="6"
            class="w-20"
          > 
            <div class="addPro pro"  @click="addCar">
              <i class="icon iconfont icon-jia3"></i>
              <span>Add parking permit</span>
            </div>
          </Col>
          <Col
            :md="12"
            :xl="8"
            :xxl="6"
            v-for="(item, index) in CarList"
            :key="'releaseInt-' + index"
            class="w-20"
            v-if="CarList.length"
          > 
            <div class="pro" >
              <div class="pro-top">
                <div class="pro-top-l">
                  <h3>Contact：{{item.contactName}}</h3>
                  <p>Mobile number：{{item.contactPhone}}</p>
                  <p>Driver's name：{{item.driverName}}</p>
                  <p>Driver’s mobile number：{{item.driverPhone}}</p>
                </div>
                <div class="pro-top-r">
                  <h4>{{item.number}}</h4>
                  <p>Vehicle tonnage：{{item.tonnage}}ton</p>
                </div>
                <!-- <div class="state-Type">
                    <span v-if="item.commandId == 1" style="color:#1890ff;">状态：新增</span>
                    <span v-if="item.commandId == 2" style="color:#fe781d;">状态：修改</span>
                    <span v-if="item.commandId == 3" style="color:#009944;">状态：删除</span>
                </div> -->
              </div>
              <div class="pro-tool">
                <div class="pro-tool-item" @click="editModal(item)" style="color:#1890ff">Edit</div>
                <div class="pro-tool-line"></div>
                <div class="pro-tool-item z-del">
                  <Poptip confirm title="您确认删除这条内容吗？"  @on-ok="delItem(item)" style="color:#ff0000">Delete</Poptip>
                </div>
              </div>
            </div>
          </Col>
        </Row>
        <!-- <div class="my-page" v-if="totalCount > pageSize">
          <Page
            show-total
            show-elevator
            :page-size="pageSize"
            :current="pageIndex"
            :total="totalCount"
            @on-change="changePage"
            @on-page-size-change="changePageSize"
          />
        </div> -->
      </div>
    </template>
    <addCar :show="carShow" @close="closeModal" :ModalTitle="ModalTitle" :options="options" @addFinsh="addFinsh"></addCar>
    <!-- <emptyList v-if="!CarList.length"></emptyList> -->
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
// import emptyList from "@components/emptyList/emptyList";
import addCar from "./add-car";

export default {
  name: "exhibition-car-no",
  props:['addShow'],
  data() {
    return {
      deleted: false,
      edit: false,
      list: null,
      editInfo: null,
      delInfo: null,

      pageSize: 20,
      pageIndex: 1,
      totalCount: 0,
      timer: null,
      carShow:false,
      ModalTitle:'', // 弹框标题
      CarList:[], 
      options:{},
    };
  },
  watch:{
    addShow(val){
      if(val){
        this.addCar();
      }
    }
  },
  computed: {
    header() { return this.$store.state.header},
    joinInfo() {
      return JSON.parse(localStorage.getItem('vuex')).loginModule.joinInfo;
    },
    option() {
      return {
        CompId: this.company.id,
        PageSize: this.pageSize,
        PageIndex: this.pageIndex,

        Wheres: {
          Type: 0,
          Wheres: {
            WhereGroupOperator: 0,
            Predicates: [
              {
                type: 1,
                wheres: {
                  WhereOperator: 0,
                  Label: "IsApply",
                  Value: 1
                }
              }
            ]
          }
        }
      };
    }
  },
  components: {
    addCar,
  },
  created() {
    this.init();
  },
  methods: {
    closeModal(){ // 关闭弹框
      this.carShow = false;
      this.$emit('closeModal')
    },
    addCar() { // 添加车证
      this.carShow = true;
      this.ModalTitle = "Add parking permit";
      this.options = {
        msg:null,
        model:null,
      }
    },
    editModal(item){
      this.carShow = true;
      this.ModalTitle = "Edit parking permit";
      this.options = {
        msg:item,
        model:'edit',
        type:'1',
      }
    },
    delItem(item){ // 删除
      console.log(item);
      this.$http.delete(`/api/vehicleDown?recordId=${item.id}`,this.header)
                    .then(res=>{
                      if(res.status === 200 && res.data.successed){
                        this.$Message.success("删除成功！");
                        this.getCarList();
                      }else{
                        this.$Message.error("删除失败，请重新尝试");
                      }
                    })
    },
    init(){
      this.getCarList();
    },
    getCarList(){  // 未确认
      this.$http.get(`/api/VehicleDown/GetListByJoinId?joinId=${this.joinInfo.joinId}`,this.header)
                .then(res=>{
                  if(res.status === 200 && res.data.length){
                    this.CarList = res.data;
                    console.log("未确认：",this.CarList)
                  } else {
                    this.CarList = [];
                  }
                })
    },
    // 添加完成
    addFinsh(){
      this.getCarList();
    }
  },
};
</script>

<style scoped lang="scss">
.my-item {
  min-width: 600px;
  padding: 24px;

  &-box {
    background-color: #fff;
    margin-bottom: 30px;
  }

  .addPro{
    padding:40px;
    .icon{
      font-size: 60px;
      text-align: center;
      display: block;
      color:#999;
    }
    span{
      display: block;
      font-size: 18px;
      color:#999;
      text-align: center;
      position: relative;
      top:-5px;
    }
  }
  .pro {
    margin-bottom: 20px;
    position: relative;
    height: 210px;
    background-color: #fafafa;
  	box-shadow: 0px 2px 6px 0px 
		rgba(136, 156, 176, 0.1);
    &-top {
      width: 100%;
      background: #fff;
      padding:20px;
      display: flex;
      position: relative;
      &-l{
        width: 65%;
        h3{
          font-size: 18px;
          font-weight: 600;
          line-height: 20px;
          color: #333;
          padding-bottom: 10px;
        }
        p{
          font-size: 14px;
          line-height: 16px;
          padding:8px 0;
          color: #333;
        }
      }
      &-r{
        width: 40%;
        text-align: right;
        h4{
          font-size: 18px;
          line-height:32px;
          color: #333;
          width: 100%;
          border-radius: 5px;
          background-color: #d3e7ff;
          font-weight: 400;
          text-align: center;
        }
        p{
          font-size: 14px;
          line-height: 16px;
          padding:8px 0;
          color: #333;
          text-align: left;
        }
      }
      .state-Type{
        position: absolute;
        right: 20px;
        bottom: 20px;
      }
    }

    &-tool {
      display: flex;
      height: 48px;
      align-items: center;
      justify-content: space-around;
      background-color: #f7f9fa;

      &-item {
        flex: 1;
        line-height: 48px;
        font-size: 14px;
        color: #808080;
        cursor: pointer;
        text-align: center;
        &:hover {
          color: #1890ff;
        }

        &.z-del {
          &:hover {
            color: #f00;
          }
        }
      }

      &-line {
        background-color: #e8e8e8;
        font-size: 20px;
        width: 1px;
        height: 22px;
        background-color: #e8e8e8;
      }
    }
  }

  .my-page {
    padding-bottom: 50px;
  }
}
</style> 
